export const sampleData = [
  {
    first_name: 'Allen',
    last_name: 'Parker',
    work_email: 'allen.parker@freshsurvey.io',
    mobile_number: '5258958411',
    address: '7326 Walnut Hill Ln',
    city: 'Dallas',
    state: 'Texas',
    country: 'United States',
  },
  {
    first_name: 'Kim',
    last_name: 'Garrett',
    work_email: 'kim.garrett@freshsurvey.io',
    mobile_number: '6488701701',
    address: '9033 James St',
    city: 'Reed City',
    state: 'Michigan',
    country: 'United States',
  },
  {
    first_name: 'Gertrude',
    last_name: 'Murphy',
    work_email: 'gertrude.murphy@freshsurvey.io',
    mobile_number: '9227571965',
    address: '4040 Ranchview Dr',
    city: 'Orange',
    state: 'California',
    country: 'United States',
  },
  {
    first_name: 'Brett',
    last_name: 'Lowe',
    work_email: 'brett.lowe@freshsurvey.io',
    mobile_number: '4336950731',
    address: '6073 Hogan S',
    city: 'St. Louis',
    state: 'Missouri',
    country: 'United States',
  },
  {
    first_name: 'Clara',
    last_name: 'Simpson',
    work_email: 'clara.simpson@freshsurvey.io',
    mobile_number: '3561610315',
    address: '3236 Spring Hill Rd',
    city: 'Tysons',
    state: 'Virginia',
    country: 'United States',
  },
];
